import { Tx } from "./types";

// status for tx handled on back-end
export const TX_STATES = Object.freeze({
    PRE_LOAN_REQUESTED: "PRE_LOAN_REQUESTED",
    LOAN_REQUESTED: "LOAN_REQUESTED",
    CONFIRMED: "CONFIRMED",
    REJECTED: "REJECTED",
    EXPIRED: "EXPIRED",
    ERROR: "ERROR",
    IOI_REQUESTED: "IOI_REQUESTED",
    OFFERED: "OFFERED",
    SENDING: "SENDING",
    CANCELLED: "CANCELLED",
    RELEASED: "RELEASED",
    FORKED: "FORKED",
    UPGRADE_REQUESTED: "UPGRADE_REQUESTED",
    OFFERING: "OFFERING",
    WITHDRAWN: "WITHDRAWN",
});
// status for tx handled on back-end
export const ROW_STATUSES = Object.freeze({
    DONE: "Done",
    SENT: "Sent",
});

export const HUMANIZED_TX_STATES = Object.freeze({
    PRE_LOAN_REQUESTED: "Msg Sent",
    LOAN_REQUESTED: "Msg Sent",
    CONFIRMED: "Recorded",
    REJECTED: "Rejected",
    EXPIRED: "Expired",
    ERROR: "Error",
    IOI_REQUESTED: "IOI Requested",
    OFFERED: "Responded",
    SENDING: "Sending",
    CANCELLED: "Canceled",
    RELEASED: "Released",
    FORKED: "Forked",
    UPGRADE_REQUESTED: "Upgrade Requested",
    OFFERING: "Offering",
    WITHDRAWN: "Withdrawn",
});

// status for response to each tx on front-end
// possible status at updating tx entries: [WAITING, NA]
export const RESPOND_STATES = Object.freeze({
    WAITING: "respond.waiting",
    NA: "respond.not_available",
    IN: "respond.proceed",
    OUT: "respond.dismiss",
    SENT: "respond.sent", // locks response after submission
});

// status for api calls
export const REQUEST_STATES = Object.freeze({
    SENDING: "request.sending",
    ERROR: "request.error",
    SENT: "request.sent",
    NONE: "request.none",
});

export const FETCH_STATES = Object.freeze({
    FETCHING: "fetch.fetching",
    FETCHED: "fetch.fetched",
    ERROR: "fetch.error",
});

export const LOAN_TYPES = Object.freeze({
    LOAN: "LOAN",
    HOLD: "HOLD",
    BID: "BID",
});

export const OBJECTIVES = Object.freeze({
    REGULAR: "REGULAR",
    LP: "LP",
    FINANCING: "FINANCING",
});

export const HUMANIZED_OBJECTIVES = Object.freeze({
    REGULAR: "Regular (일반)",
    LP: "LP (유동성 공급)",
    FINANCING: "Financing (유동성 확보)",
});

export const HUMANIZED_TYPES = Object.freeze({
    LOAN: "Regular",
    HOLD: "EA",
    MIXED: "Mixed",
    BID: "Bid",
});

export const COLLAT_TYPES = Object.freeze({
    CA: "Cash",
    NC: "NonCash",
    CP: "CashPool",
});

export const AC_VALUES = Object.freeze({
    MIN_QTY_DEFAULT: 5,
    MAX_RATE_DEFAULT: 0,
    DIV_DEFAULT: 100,

    CALLABILITY_CALLABLE: "CALLABLE",
    CALLABILITY_NON_CALLABLE: "NON_CALLABLE",
});

export const AC_OPTION_GROUPS = Object.freeze({
    CALLABILITY_OPTIONS: [
        AC_VALUES.CALLABILITY_CALLABLE,
        AC_VALUES.CALLABILITY_NON_CALLABLE,
    ],
    CALLABILITY_DISPLAY: ["Callable", "Non Callable"],
});

export const defaultAC = Object.freeze({
    minQuantityPercent: AC_VALUES.MIN_QTY_DEFAULT,
    maxRateBps: AC_VALUES.MAX_RATE_DEFAULT,
    maxDiv: AC_VALUES.DIV_DEFAULT,
});

export const defaultToggleAC = Object.freeze({ includesAC: true });

export const defaultFund = Object.freeze({ label: "", value: "" });

export const LOCAL_STORAGE_DEFAULT_VALUES = Object.freeze({
    [Tx.AC_STORAGE_VALUE]: defaultAC,
    [Tx.AC_STORAGE_TOGGLE]: defaultToggleAC,
    [Tx.FUND_CODE_STORAGE_VALUE]: defaultFund,
});

export const TX_INIT_ERROR_MESSAGES = Object.freeze({
    dividend: "Div Liability must be below 100.",
    maxRateBps: "Max Rate must be below 10000.",
    Callability: "At least one callability must be selected.",
    minQuantityPercent: "Min Qty must be between 1 and 100.",
    multiplier: "The multiplier must be between 0.01 and 100.",
});

export const TX_AGG_TABLE_INFO = {
    "Details Offer Qty": "aggSum",
    "Details Offer Rate": "aggRate",
    "Details Offer Amount": "aggSum",
    "Details Type": "aggType",
    "Details Status": "aggName",
    "Details Fund Name": "aggName",
    "Details List Name": "aggName",
    "Details Id": "aggId",
};
